<template>
    <div class="p-1">
        <uploader :autoStart="true" :ref="'doc_uploader'" :options="renderUploadOptions()" class="uploader-example">
            <uploader-unsupport v-show="false"></uploader-unsupport>
                <uploader-drop style="background-color:rgb(231, 241, 255);">
                    <b-row>
                        <b-col cols="12">
                            <p style="margin-top: 5px ;margin-bottom: 0;">Drop files here to upload or</p>
                        </b-col>
                        <b-col cols="12">
                            <uploader-btn style="margin-bottom: 0;">Select file</uploader-btn>
                        </b-col>
                    </b-row>
                </uploader-drop>
            <uploader-list></uploader-list>
        </uploader>
        <b-overlay :show="is_loading" no-wrap>

        </b-overlay>
    </div>
</template>

<script>
import { sopState, sopMethods, authComputed } from '@/state/helpers';
export default {
    data:() => ({
        is_loading: false,
    }),
    computed:{
        ...sopState, ...authComputed,
    },
    watch:{
        //eslint-disable-next-line
        currentUser(updated_token){
            this.$refs.doc_uploader.uploader.opts.headers.Authorization = 'Bearer ' + updated_token;
        }
    },
    methods:{
        ...sopMethods,
        renderUploadOptions() {
            let params = {
                client_sop_type_id : this.sop_data.id,
            }
            var storage = window.localStorage;
            var AUTH_TOKEN = storage.getItem('x_token');
            var url = process.env.VUE_APP_API_BASEURL + 'api/clientdocadmin/uploadsop';
            var options = {
                target: url,
                query: params,
                headers: {
                    'Access-Control-Allow-Credentials': true,
                    'X-Requested-With': 'XMLHttpRequest',
                    'Access-Control-Allow-Origin': '*',
                    'Authorization': 'Bearer ' + AUTH_TOKEN,
                },
                testChunks: false,
                fileParameterName: 'sop', //Set the upload post param which will contain the binary payload
                singleFile: true, //Limit upload to one file
                accept: '.pdf', // Only allow PDF files
            }
            return options;
        },
    },
    mounted(){
        let el = this;
        this.$refs.doc_uploader.uploader.on('fileError', function () {
            el.is_loading = false;
        })
        this.$refs.doc_uploader.uploader.on('uploadStart', function () {
            el.is_loading = true;
        })
        this.$refs.doc_uploader.uploader.on('complete', function () {
            el.is_loading = false;
            el.$eventHub.$emit('refreshRevisions')
        })
    },
}
</script>

<style>

</style>